import styled from 'styled-components';

export const Container = styled.main`
  width: 100vw;
  height: fit-content;
  min-height: 100vh;
  margin-top: 5.4075rem;
`;
